import { Component } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: '[app-server-admin]',
    templateUrl: './server-admin.component.html',
    styleUrls: ['./server-admin.component.css'],
    standalone: false
})
export class ServerAdminComponent {

  private selectedTab: string = "settings";

  public apply: Subject<void> = new Subject<void>();

  public openTab(name: string) {
    this.selectedTab = name;
  }
  public isSelected(name: string): boolean {
    return this.selectedTab == name;
  }

  public Apply()
  {
    this.apply.next();
  }
}
